// Thumbnail/EffectControls.js

import React from 'react';

function EffectControls({ currentEffect, onToggleEffect, language }) {
    const effects = [
        { key: 'none', icon: '', label: language === 'KR' ? '효과 없음' : 'No Effect' },
        { key: 'raindrops', icon: '💧', label: language === 'KR' ? '물방울' : 'Raindrops' },
        { key: 'rainlines', icon: '🌧️', label: language === 'KR' ? '빗줄기' : 'Rain Lines' },
        { key: 'bubbles', icon: '🫧', label: language === 'KR' ? '비눗방울' : 'Bubbles' },
        { key: 'snowflakes', icon: '❄️', label: language === 'KR' ? '눈' : 'Snowflakes' },
        { key: 'leaves', icon: '🍂', label: language === 'KR' ? '낙엽' : 'Leaves' },
        { key: 'flowers', icon: '🌸', label: language === 'KR' ? '꽃잎' : 'Flower Petals' },
        { key: 'hearts', icon: '💖', label: language === 'KR' ? '하트' : 'Hearts' },
        { key: 'stars', icon: '⭐', label: language === 'KR' ? '별' : 'Stars' }
    ];

    return (
        <div className="control-section">
            <h3>✨ {language === 'KR' ? '감성 효과' : 'Emotional Effects'}</h3>
            <div>
                {effects.map(effect => (
                    <button
                        key={effect.key}
                        className={`effect-btn ${currentEffect === effect.key ? 'active' : ''}`}
                        onClick={() => onToggleEffect(effect.key)}
                    >
                        {effect.icon} {effect.label}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default EffectControls;